// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoadingState_wrapper__6dzac","message":"LoadingState_message__vvK2v","lazyWrapper":"LoadingState_lazyWrapper__eYFIl"};